/**
 * Coastal Calm — Shopify Theme JavaScript
 */
(function () {
  'use strict';

  // add a small HTML class so CSS can target JS-enabled state (prevents FOUC)
  try { document.documentElement.classList.add('js'); } catch (e) { /* ignore */ }

  /* ========================================
     MOBILE MENU
  ======================================== */
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileCloseBtn = document.querySelector('.mobile-menu__close');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileCloseBtn && mobileMenu) {
    mobileCloseBtn.addEventListener('click', () => {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* ========================================
     CART DRAWER
  ======================================== */
  const cartToggleBtns = document.querySelectorAll('[data-cart-toggle]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartCloseBtn = document.querySelector('.cart-drawer__close');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartToggleBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* AJAX Cart Helpers */
  window.CoastalCalm = window.CoastalCalm || {};

  window.CoastalCalm.showToast = function (message) {
    let toast = document.getElementById('coastal-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'coastal-toast';
      Object.assign(toast.style, {
        position: 'fixed',
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'var(--color-primary, #AB9474)',
        color: '#fff',
        padding: '12px 24px',
        borderRadius: '30px',
        zIndex: '10000',
        fontSize: '14px',
        fontFamily: 'var(--font-body)',
        fontWeight: '500',
        opacity: '0',
        transition: 'opacity 0.3s ease',
        pointerEvents: 'none',
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
      });
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.opacity = '1';
    setTimeout(() => { toast.style.opacity = '0'; }, 3000);
  };

  window.CoastalCalm.addToCart = function (variantId, quantity) {
    quantity = quantity || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(res => res.json().then(data => ({ ok: res.ok, data: data })))
      .then(resObj => {
        if (!resObj.ok) {
          CoastalCalm.showToast(resObj.data.description || "Stocks over. You cannot add more items to the cart.");
          return resObj.data;
        }
        CoastalCalm.refreshCart();
        openCart();
        return resObj.data;
      })
      .catch(err => console.error('Add to cart error:', err));
  };

  window.CoastalCalm.updateCart = function (key, quantity) {
    // ── Optimistic UI: update instantly before network responds ──
    const btns = document.querySelectorAll(`[onclick*="'${key}'"]`);
    btns.forEach(btn => {
      const row = btn.closest('.cart-drawer__item, .cart-page__item');
      if (!row) return;

      const qtyInput = row.querySelector('input[type="number"]');
      const priceEl = row.querySelector('.cart-drawer__item-price, .cart-page__item-price');
      if (qtyInput) {
        const currentQty = parseInt(qtyInput.value) || 0;
        const unitPrice = currentQty > 0 ? row.dataset.unitPrice : 0;

        if (quantity <= 0) {
          // Animate removal
          row.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
          row.style.opacity = '0';
          row.style.transform = 'translateX(20px)';
        } else {
          // Update qty counter immediately
          qtyInput.value = quantity;
          // Recalculate line price if we know the unit price
          if (unitPrice && priceEl) {
            priceEl.textContent = CoastalCalm.formatMoney(parseInt(unitPrice) * quantity);
          }
          // Update +/- onclick values optimistically
          const minusBtn = row.querySelector('button:first-child');
          const plusBtn = row.querySelector('button:last-child');
          if (minusBtn) minusBtn.setAttribute('onclick', `CoastalCalm.updateCart('${key}', ${quantity - 1})`);
          if (plusBtn) plusBtn.setAttribute('onclick', `CoastalCalm.updateCart('${key}', ${quantity + 1})`);
        }
      }
    });

    // ── Network: confirm with server, then do a clean refresh ──
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(res => res.json().then(data => ({ ok: res.ok, data: data })))
      .then(resObj => {
        const data = resObj.data;
        if (!resObj.ok || data.status === 422) {
          CoastalCalm.showToast(data.description || data.message || "Stocks over. You cannot add more items.");
        } else {
          const updatedItem = data.items ? data.items.find(item => item.key === key) : null;
          if (updatedItem && updatedItem.quantity < quantity) {
            CoastalCalm.showToast("Stocks over. Maximum quantity reached for this item.");
          }
        }
        CoastalCalm.refreshCart();
        return data;
      })
      .catch(err => console.error('Update cart error:', err));
  };

  window.CoastalCalm.refreshCart = function () {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // Update cart count badge
        const countEls = document.querySelectorAll('.cart-count');
        countEls.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        // Update drawer contents
        const itemsContainer = document.querySelector('.cart-drawer__items');
        const emptyEl = document.querySelector('.cart-drawer__empty');
        const footerEl = document.querySelector('.cart-drawer__footer');
        const subtotalEl = document.querySelector('.cart-drawer__subtotal span.cart-drawer__subtotal-price');
        const checkoutEl = document.querySelector('.cart-drawer__checkout-btn .cart-drawer__checkout-price');

        if (!itemsContainer) return;

        if (cart.item_count === 0) {
          itemsContainer.innerHTML = '';
          if (emptyEl) emptyEl.style.display = 'block';
          if (footerEl) footerEl.style.display = 'none';
          return;
        }

        if (emptyEl) emptyEl.style.display = 'none';
        if (footerEl) footerEl.style.display = 'block';

        let html = '';
        cart.items.forEach(item => {
          html += `
            <div class="cart-drawer__item" data-unit-price="${item.final_price}">
              <div class="cart-drawer__item-image">
                <img src="${item.image || ''}" alt="${item.title}" loading="lazy">
              </div>
              <div class="cart-drawer__item-info">
                <div class="cart-drawer__item-title">${item.title}</div>
                <div class="cart-drawer__item-price">${CoastalCalm.formatMoney(item.final_line_price)}</div>
                <div class="quantity-selector">
                  <button type="button" onclick="CoastalCalm.updateCart('${item.key}', ${item.quantity - 1})">−</button>
                  <input type="number" value="${item.quantity}" min="0" readonly>
                  <button type="button" onclick="CoastalCalm.updateCart('${item.key}', ${item.quantity + 1})">+</button>
                </div>
              </div>
            </div>`;
        });
        itemsContainer.innerHTML = html;

        const formattedTotal = CoastalCalm.formatMoney(cart.total_price);
        if (subtotalEl) subtotalEl.textContent = formattedTotal;
        if (checkoutEl) checkoutEl.textContent = formattedTotal;

        // If we're on the dedicated cart page, silently fetch and swap its HTML so totals sync perfectly
        if (window.location.pathname === '/cart') {
          fetch('/cart')
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newCartNode = doc.getElementById('MainCartSection');
              const currentCartNode = document.getElementById('MainCartSection');
              if (newCartNode && currentCartNode) {
                currentCartNode.innerHTML = newCartNode.innerHTML;
              }
            });
        }
      });
  };

  window.CoastalCalm.formatMoney = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ========================================
     ADD TO CART FORMS
  ======================================== */
  document.querySelectorAll('form[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = form.querySelector('[name="id"]').value;
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value || 1);
      CoastalCalm.addToCart(parseInt(variantId), qty);
    });
  });

  /* ========================================
     QUANTITY SELECTORS (standalone)
  ======================================== */
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('input');
    const minus = selector.querySelector('[data-qty-minus]');
    const plus = selector.querySelector('[data-qty-plus]');

    if (minus) {
      minus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    if (plus) {
      plus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        const max = input.hasAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;
        if (val < max) {
          input.value = val + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (window.CoastalCalm && window.CoastalCalm.showToast) {
          window.CoastalCalm.showToast("Maximum quantity reached for this item.");
        }
      });
    }
  });

  /* ========================================
     ACCORDION
  ======================================== */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isOpen = this.getAttribute('aria-expanded') === 'true';

      this.setAttribute('aria-expanded', !isOpen);

      if (!isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = '0';
      }
    });
  });

  /* ========================================
     TESTIMONIAL SLIDER
  ======================================== */
  const testimonialSlider = document.querySelector('[data-testimonial-slider]');
  if (testimonialSlider) {
    const slides = testimonialSlider.querySelectorAll('[data-slide]');
    const dots = testimonialSlider.querySelectorAll('.testimonial-dot');
    let current = 0;

    function showSlide(index) {
      slides.forEach((s, i) => {
        s.style.display = i === index ? 'block' : 'none';
      });
      dots.forEach((d, i) => {
        d.classList.toggle('active', i === index);
      });
      current = index;
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => showSlide(i));
    });

    // Auto-advance
    setInterval(() => {
      showSlide((current + 1) % slides.length);
    }, 6000);

    showSlide(0);
  }

  /* ========================================
     GALLERY LIGHTBOX
  ======================================== */
  const lightbox = document.querySelector('.lightbox');
  const lightboxImg = lightbox ? lightbox.querySelector('img') : null;
  const lightboxClose = lightbox ? lightbox.querySelector('.lightbox__close') : null;

  document.querySelectorAll('[data-lightbox]').forEach(item => {
    item.addEventListener('click', function () {
      const src = this.querySelector('img')?.src || this.dataset.lightbox;
      if (lightboxImg && src) {
        lightboxImg.src = src;
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  if (lightboxClose) {
    lightboxClose.addEventListener('click', () => {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ========================================
     PRODUCT GALLERY THUMBNAILS
  ======================================== */
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = this.closest('.product-gallery').querySelector('.product-gallery__main img');
      const src = this.querySelector('img').src;
      if (mainImg) mainImg.src = src;

      this.closest('.product-gallery__thumbs').querySelectorAll('.product-gallery__thumb').forEach(t => {
        t.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  /* ========================================
     COLLECTION FILTER TABS (Removed JS to allow native URL navigation)
  ======================================== */

  /* ========================================
     SERVICE MENU SIDEBAR NAV
  ======================================== */
  document.querySelectorAll('.service-sidebar__link').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetEl = document.getElementById(targetId);
      if (targetEl) {
        window.scrollTo({
          top: targetEl.offsetTop - 120,
          behavior: 'smooth'
        });
      }
      this.closest('.service-sidebar__nav').querySelectorAll('.service-sidebar__link').forEach(l => {
        l.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  /* ========================================
     TIER TABS (service menu)
  ======================================== */
  document.querySelectorAll('.tier-tab').forEach(tab => {
    tab.addEventListener('click', function () {
      this.closest('.tier-tabs').querySelectorAll('.tier-tab').forEach(t => {
        t.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  /* ========================================
     DENOMINATION SELECTOR (gift cards)
  ======================================== */
  document.querySelectorAll('.denomination-option').forEach(opt => {
    opt.addEventListener('click', function () {
      this.closest('.denomination-grid').querySelectorAll('.denomination-option').forEach(o => {
        o.classList.remove('selected');
      });
      this.classList.add('selected');

      const input = document.querySelector('[name="denomination"]');
      if (input) input.value = this.dataset.value;
    });
  });

  /* ========================================
     INIT CART ON PAGE LOAD
  ======================================== */
  if (typeof CoastalCalm !== 'undefined') {
    CoastalCalm.refreshCart();
  }

  /* ========================================
     SCROLL REVEAL ANIMATIONS
  ======================================== */
  const revealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale, .stagger-children, .line-grow');

  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -60px 0px'
    });

    revealElements.forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    // Fallback: show everything for browsers without IO
    revealElements.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ========================================
     HEADER SCROLL SHRINK
  ======================================== */
  var lastScrollTop = 0;
  var header = document.querySelector('.site-header');

  if (header) {
    window.addEventListener('scroll', function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 80) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScrollTop = scrollTop;
    }, { passive: true });
  }

  /* ========================================
     SMOOTH PARALLAX (hero image)
  ======================================== */
  var parallaxEls = document.querySelectorAll('.parallax-slow');
  if (parallaxEls.length > 0) {
    window.addEventListener('scroll', function () {
      var scrollY = window.pageYOffset;
      parallaxEls.forEach(function (el) {
        el.style.transform = 'translateY(' + scrollY * 0.15 + 'px)';
      });
    }, { passive: true });
  }

  /* ========================================
     CAROUSEL SCROLLING ARROWS
  ======================================== */
  document.querySelectorAll('.carousel-next').forEach(btn => {
    btn.addEventListener('click', function () {
      const container = this.closest('.container');
      if (container) {
        const row = container.querySelector('.scroll-row');
        if (row) {
          row.scrollBy({ left: 340, behavior: 'smooth' });
        }
      }
    });
  });

  document.querySelectorAll('.carousel-prev').forEach(btn => {
    btn.addEventListener('click', function () {
      const container = this.closest('.container');
      if (container) {
        const row = container.querySelector('.scroll-row');
        if (row) {
          row.scrollBy({ left: -340, behavior: 'smooth' });
        }
      }
    });
  });

  /* ========================================
     COLLECTION FILTER DRAWER
  ======================================== */
  (function () {
    var filterDrawer = document.getElementById('FilterDrawer');
    var filterOverlay = document.getElementById('FilterDrawerOverlay');
    var filterOpenBtn = document.getElementById('FilterDrawerBtn');
    var filterCloseBtn = document.getElementById('FilterDrawerClose');

    if (!filterDrawer) return; // Not on a collection page

    function openFilterDrawer() {
      filterDrawer.classList.add('is-open');
      filterOverlay.classList.add('is-open');
      filterOpenBtn.setAttribute('aria-expanded', 'true');
      filterOpenBtn.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }

    function closeFilterDrawer() {
      filterDrawer.classList.remove('is-open');
      filterOverlay.classList.remove('is-open');
      filterOpenBtn.setAttribute('aria-expanded', 'false');
      filterOpenBtn.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    if (filterOpenBtn) filterOpenBtn.addEventListener('click', openFilterDrawer);
    if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilterDrawer);
    if (filterOverlay) filterOverlay.addEventListener('click', closeFilterDrawer);

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && filterDrawer.classList.contains('is-open')) {
        closeFilterDrawer();
      }
    });

    /* ── Accordion filter groups ── */
    document.querySelectorAll('.filter-group__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isExpanded = this.getAttribute('aria-expanded') === 'true';
        var body = this.nextElementSibling;
        var chevron = this.querySelector('.filter-group__chevron');

        if (isExpanded) {
          // Collapse
          body.style.maxHeight = '0';
          this.setAttribute('aria-expanded', 'false');
          if (chevron) chevron.textContent = 'expand_more';
        } else {
          // Expand
          body.style.maxHeight = body.scrollHeight + 'px';
          this.setAttribute('aria-expanded', 'true');
          if (chevron) chevron.textContent = 'expand_less';
        }
      });
    });

    /* ── Price bucket → Shopify filter params ── */
    var priceGteInput = document.getElementById('FilterPriceGte');
    var priceLteInput = document.getElementById('FilterPriceLte');

    document.querySelectorAll('input[name="price_bucket"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!this.checked) return;
        var parts = this.value.split('_');
        var min = parts[0]; // in cents
        var max = parts[1]; // in cents, may be empty for "& above"

        if (priceGteInput) priceGteInput.value = min ? (parseInt(min) / 100).toFixed(2) : '';
        if (priceLteInput) priceLteInput.value = max ? (parseInt(max) / 100).toFixed(2) : '';
      });
    });

    /* ── Form submission: build clean URL with all params ── */
    var filterForm = document.getElementById('CollectionFiltersForm');
    if (filterForm) {
      filterForm.addEventListener('submit', function (e) {
        e.preventDefault();

        var formData = new FormData(filterForm);
        var params = new URLSearchParams();

        // Keep current sort_by if set
        var currentSort = new URLSearchParams(window.location.search).get('sort_by');
        if (currentSort) params.set('sort_by', currentSort);

        // Append all standard filter checkboxes
        formData.forEach(function (value, key) {
          if (key === 'price_bucket') return; // handled separately
          if (key === 'sort_by' || key === 'type') return; // already handled
          if (value !== '') {
            params.append(key, value);
          }
        });

        // Append price range (already converted by radio handler)
        var gte = priceGteInput ? priceGteInput.value : '';
        var lte = priceLteInput ? priceLteInput.value : '';
        if (gte !== '') params.set('filter.v.price.gte', gte);
        if (lte !== '') params.set('filter.v.price.lte', lte);

        window.location.href = window.location.pathname + '?' + params.toString();
      });
    }
  })();

})();


